import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.forms.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-admin-forms-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.forms.item/view.scss */
@charset "UTF-8";
:host {
  display: block;
  width: 100%;
}

.admin-form-page {
  color: #0f172a;
}

.admin-form-back {
  display: inline-flex;
  margin-bottom: 1.1rem;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.admin-form-state,
.admin-form-empty {
  display: flex;
  min-height: 280px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 26px;
  background: #fff;
  color: #64748b;
  text-align: center;
}

.admin-form-spinner {
  width: 34px;
  height: 34px;
  margin-bottom: 1rem;
  border: 3px solid #e0e7ff;
  border-top-color: #4f46e5;
  border-radius: 999px;
  animation: admin-form-spin 800ms linear infinite;
}

@keyframes admin-form-spin {
  to {
    transform: rotate(360deg);
  }
}
.admin-form-hero,
.admin-form-panel,
.admin-form-summary,
.admin-form-crf-status,
.admin-form-result,
.admin-form-actions,
.admin-form-history {
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 22px 56px rgba(15, 23, 42, 0.07);
}

.admin-form-hero {
  overflow: hidden;
  padding: 1.4rem;
  background: radial-gradient(circle at right top, rgba(99, 102, 241, 0.18), transparent 30%), linear-gradient(180deg, #fff, #f8faff);
}

.admin-form-hero__main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.admin-form-eyebrow {
  color: #6366f1;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.admin-form-hero h1 {
  margin-top: 0.55rem;
  font-size: 28px;
  font-weight: 850;
  letter-spacing: -0.04em;
}

.admin-form-hero p,
.admin-form-panel__head p {
  margin-top: 0.65rem;
  color: #64748b;
  font-size: 13px;
  line-height: 1.7;
}

.admin-form-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}

.admin-form-badges span {
  border-radius: 999px;
  padding: 0.42rem 0.7rem;
  font-size: 11px;
  font-weight: 800;
}

.admin-form-subject {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.admin-form-subject div,
.admin-form-summary div {
  padding: 0.8rem 0.9rem;
  border: 1px solid #e0e7ff;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.84);
}

.admin-form-subject span,
.admin-form-summary span {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.admin-form-subject strong,
.admin-form-summary strong {
  display: block;
  margin-top: 0.28rem;
  color: #172554;
  font-size: 14px;
  font-weight: 800;
}

.admin-form-crf-status {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  align-items: center;
  gap: 0.9rem;
  padding: 1rem;
}

.admin-form-crf-status__item {
  min-width: 0;
}

.admin-form-crf-status__item > div {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-form-crf-status__item span {
  color: #6366f1;
  font-size: 10px;
  font-weight: 800;
}

.admin-form-crf-status__item strong {
  color: #1e293b;
  font-size: 13px;
  font-weight: 800;
}

.admin-form-crf-status__item em {
  display: inline-flex;
  margin-top: 0.55rem;
  border-radius: 999px;
  padding: 0.3rem 0.55rem;
  font-size: 10px;
  font-style: normal;
  font-weight: 800;
}

.admin-form-crf-status__item p {
  margin-top: 0.45rem;
  color: #64748b;
  font-size: 10px;
  line-height: 1.5;
}

.admin-form-crf-status__divider {
  width: 22px;
  height: 1px;
  background: #cbd5e1;
}

.admin-form-notice {
  border: 1px solid #c7d2fe;
  border-radius: 12px;
  background: #eef2ff;
  padding: 0.9rem 1rem;
}

.admin-form-notice strong {
  color: #3730a3;
  font-size: 12px;
  font-weight: 800;
}

.admin-form-notice p {
  margin-top: 0.25rem;
  color: #4f46e5;
  font-size: 11px;
  line-height: 1.6;
}

.admin-form-empty {
  padding: 2rem;
}

.admin-form-empty__icon {
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border-radius: 16px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 20px;
  font-weight: 900;
}

.admin-form-empty h2 {
  margin-top: 1rem;
  color: #0f172a;
  font-size: 20px;
  font-weight: 800;
}

.admin-form-empty p {
  max-width: 580px;
  margin-top: 0.65rem;
  font-size: 13px;
  line-height: 1.7;
}

.admin-form-empty ul {
  display: grid;
  gap: 0.45rem;
  margin-top: 1rem;
  color: #475569;
  font-size: 12px;
  text-align: left;
}

.admin-form-empty li::before {
  content: "✓";
  margin-right: 0.55rem;
  color: #4f46e5;
  font-weight: 900;
}

.admin-form-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  padding: 0.9rem;
}

.admin-form-result {
  padding: 1.1rem;
  border-color: #c7d2fe;
  background: linear-gradient(180deg, #ffffff 0%, #f8faff 100%);
}

.admin-form-result.is-flagged {
  border-color: #fecaca;
  background: linear-gradient(180deg, #ffffff 0%, #fff7f7 100%);
}

.admin-form-result.is-warning {
  border-color: #fde68a;
  background: linear-gradient(180deg, #ffffff 0%, #fffbeb 100%);
}

.admin-form-result__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.admin-form-result__head h2 {
  margin-top: 0.45rem;
  font-size: 19px;
  font-weight: 850;
}

.admin-form-result__head > span {
  border-radius: 999px;
  background: #eef2ff;
  padding: 0.4rem 0.65rem;
  color: #4338ca;
  font-size: 10px;
  font-weight: 800;
}

.admin-form-result__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.7rem;
  margin-top: 1rem;
}

.admin-form-result__grid > div {
  border: 1px solid #e0e7ff;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  padding: 0.8rem 0.9rem;
}

.admin-form-result__grid span {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.admin-form-result__grid strong {
  display: block;
  margin-top: 0.28rem;
  color: #172554;
  font-size: 14px;
  font-weight: 850;
}

.admin-form-result.is-flagged .admin-form-result__grid strong {
  color: #b91c1c;
}

.admin-form-result.is-warning .admin-form-result__grid strong {
  color: #a16207;
}

.admin-form-mmse-domains {
  display: grid;
  gap: 0.55rem;
  margin-top: 1rem;
}

.admin-form-mmse-domain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.92);
  padding: 0.75rem 0.85rem;
}

.admin-form-mmse-domain > div {
  min-width: 0;
}

.admin-form-mmse-domain > div:last-child {
  flex: 0 0 auto;
  text-align: right;
}

.admin-form-mmse-domain strong,
.admin-form-mmse-domain span {
  display: block;
}

.admin-form-mmse-domain strong {
  color: #1e293b;
  font-size: 13px;
  font-weight: 850;
}

.admin-form-mmse-domain span {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 10px;
  line-height: 1.5;
}

.admin-form-mmse-comment,
.admin-form-mmse-notes {
  margin-top: 1rem;
  border-radius: 16px;
  background: #f8fafc;
  padding: 0.85rem 0.95rem;
}

.admin-form-mmse-comment__title,
.admin-form-mmse-notes span {
  color: #475569;
  font-size: 11px;
  font-weight: 850;
}

.admin-form-mmse-comment ul {
  display: grid;
  gap: 0.38rem;
  margin-top: 0.55rem;
}

.admin-form-mmse-comment li,
.admin-form-mmse-notes p {
  color: #334155;
  font-size: 11px;
  line-height: 1.65;
}

.admin-form-mmse-comment li::before {
  content: "•";
  margin-right: 0.45rem;
  color: #6366f1;
  font-weight: 900;
}

.admin-form-mmse-notes {
  display: grid;
  gap: 0.75rem;
}

.admin-form-mmse-notes p {
  margin: 0.28rem 0 0;
  white-space: pre-wrap;
}

.admin-form-result > p {
  margin: 0.8rem 0 0;
  color: #64748b;
  font-size: 11px;
  line-height: 1.6;
}

.admin-form-panel {
  padding: 1.15rem;
}

.admin-form-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.25rem 0.25rem 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.admin-form-panel__head h2 {
  margin-top: 0.45rem;
  font-size: 21px;
  font-weight: 850;
}

.admin-form-panel__head > span {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #f1f5f9;
  padding: 0.42rem 0.7rem;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
}

.admin-form-questions {
  display: grid;
  gap: 0.85rem;
  padding-top: 1rem;
}

.admin-form-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem;
}

.admin-form-actions__nav,
.admin-form-actions__save {
  display: flex;
  gap: 0.6rem;
}

.admin-form-button {
  min-height: 42px;
  border-radius: 14px;
  padding: 0.65rem 1rem;
  font-size: 12px;
  font-weight: 800;
  transition: transform 160ms ease, opacity 160ms ease;
}

.admin-form-button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.admin-form-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.admin-form-button--ghost {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}

.admin-form-button--secondary {
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  color: #4338ca;
}

.admin-form-button--primary {
  background: #4f46e5;
  color: #fff;
  box-shadow: 0 14px 30px rgba(79, 70, 229, 0.22);
}

.admin-form-history {
  padding: 1.1rem;
}

.admin-form-history__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.admin-form-history__head h2 {
  font-size: 15px;
  font-weight: 850;
}

.admin-form-history__head p {
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 11px;
}

.admin-form-history__head > span {
  color: #6366f1;
  font-size: 11px;
  font-weight: 750;
}

.admin-form-history__list {
  display: grid;
  gap: 0.55rem;
  margin-top: 0.8rem;
  transition: opacity 160ms ease;
}

.admin-form-history__list.is-loading {
  opacity: 0.45;
}

.admin-form-history__item {
  border-radius: 14px;
  background: #f8fafc;
  padding: 0.75rem 0.85rem;
  font-size: 11px;
}

.admin-form-history__summary {
  display: block;
  color: #1e293b;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.6;
  word-break: keep-all;
}

.admin-form-history__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  margin-top: 0.35rem;
}

.admin-form-history__meta span {
  color: #64748b;
}

.admin-form-history__meta span + span::before {
  content: "·";
  margin-right: 0.55rem;
  color: #cbd5e1;
}

.admin-form-history__pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.9rem;
}

.admin-form-history__pagination button {
  min-width: 64px;
  min-height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 11px;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
}

.admin-form-history__pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.admin-form-history__pagination span {
  min-width: 54px;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
}

@media (max-width: 767px) {
  .admin-form-hero__main,
  .admin-form-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .admin-form-badges {
    justify-content: flex-start;
  }
  .admin-form-subject,
  .admin-form-summary,
  .admin-form-result__grid {
    grid-template-columns: 1fr;
  }
  .admin-form-crf-status {
    grid-template-columns: 1fr;
  }
  .admin-form-crf-status__divider {
    width: 100%;
  }
  .admin-form-result__head {
    align-items: stretch;
    flex-direction: column;
  }
  .admin-form-result__head > span {
    align-self: flex-start;
  }
  .admin-form-mmse-domain {
    align-items: flex-start;
    flex-direction: column;
  }
  .admin-form-mmse-domain > div:last-child {
    text-align: left;
  }
  .admin-form-actions__nav,
  .admin-form-actions__save {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .admin-form-history__head {
    align-items: flex-start;
    flex-direction: column;
  }
}
/* Compact admin presentation */
.admin-form-page {
  width: min(100%, 1120px);
  padding: 20px;
}

.admin-form-back {
  margin-bottom: 12px;
  font-weight: 600;
}

.admin-form-hero,
.admin-form-panel,
.admin-form-summary,
.admin-form-crf-status,
.admin-form-result,
.admin-form-actions,
.admin-form-history,
.admin-form-empty,
.admin-form-state {
  border-color: #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
}

.admin-form-hero {
  padding: 16px;
}

.admin-form-hero h1 {
  margin: 0;
  color: #111827;
  font-size: 20px;
  font-weight: 750;
}

.admin-form-badges span {
  padding: 4px 7px;
  font-weight: 650;
}

.admin-form-subject {
  gap: 8px;
  margin-top: 12px;
}

.admin-form-subject div,
.admin-form-summary div {
  padding: 9px 10px;
  border-color: #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
}

.admin-form-subject strong,
.admin-form-summary strong {
  color: #1f2937;
}

.admin-form-summary {
  gap: 8px;
  padding: 10px;
}

.admin-form-result,
.admin-form-panel,
.admin-form-history {
  padding: 16px;
}

.admin-form-result,
.admin-form-result.is-flagged,
.admin-form-result.is-warning {
  background: #fff;
}

.admin-form-result__head {
  align-items: center;
}

.admin-form-result__head h2,
.admin-form-panel__head h2 {
  margin: 0;
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}

.admin-form-result__grid {
  gap: 8px;
  margin-top: 12px;
}

.admin-form-result__grid > div {
  padding: 10px;
  border-color: #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
}

.admin-form-result__grid strong {
  color: #1f2937;
}

.admin-form-mmse-domain {
  padding: 10px;
  border-radius: 8px;
}

.admin-form-mmse-comment,
.admin-form-mmse-notes {
  padding: 11px;
  border-radius: 8px;
}

.admin-form-panel__head {
  align-items: center;
  padding: 0 0 12px;
}

.admin-form-panel__head > span {
  padding: 0;
  border-radius: 0;
  background: transparent;
  color: #64748b;
  font-weight: 600;
}

.admin-form-questions {
  gap: 10px;
  padding-top: 12px;
}

.admin-form-actions {
  padding: 10px;
}

.admin-form-button {
  min-height: 38px;
  padding: 0 13px;
  border-radius: 8px;
  box-shadow: none;
}

.admin-form-button:hover:not(:disabled) {
  transform: none;
}

.admin-form-history__item {
  padding: 10px 11px;
  border: 1px solid #eef0f3;
  border-radius: 8px;
  background: #fafafa;
}

.admin-form-history__pagination button {
  border-radius: 7px;
}

:host ::ng-deep .admin-form-questions .question-shell,
:host ::ng-deep .results-item-answers .question-shell {
  gap: 12px;
  padding: 14px;
  border-color: #e5e7eb;
  border-radius: 9px;
  background: #fff;
  box-shadow: none;
}

:host ::ng-deep .admin-form-questions .question-shell__number {
  min-width: auto;
  padding: 3px 7px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
}

:host ::ng-deep .admin-form-questions .question-shell__title {
  color: #1f2937;
  font-size: 13px;
}

:host ::ng-deep .admin-form-questions .choice-card,
:host ::ng-deep .admin-form-questions .binary-choice__card,
:host ::ng-deep .admin-form-questions .likert-band__option,
:host ::ng-deep .admin-form-questions .clinical-block,
:host ::ng-deep .admin-form-questions .matrix-card {
  border-radius: 8px;
  box-shadow: none;
}

:host ::ng-deep .admin-form-questions .choice-card {
  padding: 10px 11px;
}

:host ::ng-deep .admin-form-questions .choice-card:hover,
:host ::ng-deep .admin-form-questions .binary-choice__card:hover,
:host ::ng-deep .admin-form-questions .likert-band__option:hover {
  transform: none;
  box-shadow: none;
}

@media (max-width: 767px) {
  .admin-form-page {
    padding: 16px;
  }
}
/* Unified admin visual hierarchy */
.admin-form-page {
  --form-accent: var(--admin-primary, #4f46e5);
  --form-soft: var(--admin-primary-soft, #eef2ff);
  margin: 0 auto;
  padding: 24px 28px 40px;
  color: var(--admin-text, #334155);
}

.admin-form-page[data-form-code=original_survey] {
  --form-accent: var(--admin-primary, #4f46e5);
  --form-soft: var(--admin-primary-soft, #eef2ff);
}

.admin-form-page[data-form-code=geriatric_depression] {
  --form-accent: var(--admin-success, #047857);
  --form-soft: var(--admin-success-soft, #ecfdf5);
}

.admin-form-page[data-form-code=mmse] {
  --form-accent: var(--admin-warning, #b45309);
  --form-soft: var(--admin-warning-soft, #fffbeb);
}

.admin-form-back {
  color: var(--admin-text-muted, #64748b);
}

.admin-form-back:hover {
  color: var(--form-accent);
}

.admin-form-state,
.admin-form-empty,
.admin-form-hero,
.admin-form-panel,
.admin-form-summary,
.admin-form-crf-status,
.admin-form-result,
.admin-form-actions,
.admin-form-history {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 14px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.admin-form-hero {
  background: radial-gradient(circle at 92% 12%, var(--form-soft) 0, rgba(255, 255, 255, 0) 32%), var(--admin-surface, #fff);
}

.admin-form-hero h1 {
  display: flex;
  align-items: center;
  color: var(--admin-text-strong, #111827);
  font-size: 25px;
}

.admin-form-hero h1::before {
  width: 8px;
  height: 8px;
  margin-right: 9px;
  border-radius: 999px;
  background: var(--form-accent);
  content: "";
}

.admin-form-hero p,
.admin-form-panel__head p {
  color: var(--admin-text-muted, #64748b);
}

.admin-form-badges span:last-child {
  background: var(--form-soft);
  color: var(--form-accent);
}

.admin-form-subject div,
.admin-form-summary div {
  border-color: var(--admin-border-soft, #edf1f5);
  border-radius: 9px;
  background: var(--admin-surface-subtle, #f8fafc);
}

.admin-form-subject strong,
.admin-form-summary strong {
  color: var(--admin-text-strong, #111827);
}

.admin-form-crf-status__item span {
  color: var(--form-accent);
}

.admin-form-notice {
  border-color: var(--form-accent);
  background: var(--form-soft);
}

.admin-form-notice strong,
.admin-form-notice p {
  color: var(--form-accent);
}

.admin-form-result__head,
.admin-form-panel__head,
.admin-form-history__head {
  padding-bottom: 12px;
  border-bottom: 1px solid var(--admin-border-soft, #edf1f5);
}

.admin-form-result__head h2,
.admin-form-panel__head h2,
.admin-form-history__head h2 {
  display: flex;
  align-items: center;
  color: var(--admin-text-strong, #111827);
}

.admin-form-result__head h2::before,
.admin-form-panel__head h2::before,
.admin-form-history__head h2::before {
  width: 7px;
  height: 7px;
  margin-right: 8px;
  border-radius: 999px;
  background: var(--form-accent);
  content: "";
}

.admin-form-result__grid > div,
.admin-form-mmse-domain,
.admin-form-mmse-comment,
.admin-form-mmse-notes,
.admin-form-history__item {
  border-color: var(--admin-border-soft, #edf1f5);
  background: var(--admin-surface-subtle, #f8fafc);
}

.admin-form-actions {
  background: linear-gradient(135deg, var(--form-soft), rgba(255, 255, 255, 0) 42%), var(--admin-surface, #fff);
}

.admin-form-button--primary {
  border-color: var(--admin-primary, #4f46e5);
  background: var(--admin-primary, #4f46e5);
}

.admin-form-button--secondary,
.admin-form-button--ghost {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface, #fff);
  color: var(--admin-text, #334155);
}

:host ::ng-deep .admin-form-questions .question-shell {
  border-color: var(--admin-border, #dce2ea);
  background: var(--admin-surface, #fff);
}

:host ::ng-deep .admin-form-questions .question-shell__number {
  background: var(--form-soft);
  color: var(--form-accent);
}

@media (max-width: 767px) {
  .admin-form-page {
    padding: 16px 16px 32px;
  }
}`],
})
export class PageAdminFormsItemComponent implements OnInit {
    public subjectId: string = '';
    public formCode: string = '';
    public loading: boolean = true;
    public saving: boolean = false;
    public submitting: boolean = false;

    public definition: any = {};
    public subject: any = {};
    public template: any = {};
    public response: any = {};
    public schema: any = { sections: [], scales: {} };
    public answers: any = {};
    public initialAnswers: any = {};
    public result: any = null;
    public revisions: any[] = [];
    public revisionPage: number = 1;
    public revisionPages: number = 0;
    public revisionTotal: number = 0;
    public revisionPageSize: number = 5;
    public revisionLoading: boolean = false;
    public sectionIdx: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) return data.data;
        return data || {};
    }

    public formTitle(): string {
        if (this.formCode === 'original_survey') {
            return '한의 검진 설문(CRF)';
        }
        return this.definition.title || this.template.title || '설문';
    }

    public async ngOnInit() {
        await this.service.init();
        this.subjectId = WizRoute.segment.id || '';
        this.formCode = WizRoute.segment.form_code || '';
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.revisionPage = 1;
        await this.service.render();
        const { code, data } = await wiz.call('get', {
            id: this.subjectId,
            form_code: this.formCode,
            revision_page: this.revisionPage,
        });
        this.loading = false;
        if (code !== 200) {
            alert((data && data.message) || '양식을 불러오지 못했습니다.');
            this.service.href('/admin/subjects/' + this.subjectId);
            return;
        }
        const value = this.payload(data);
        this.definition = value.definition || {};
        this.subject = value.subject || {};
        this.template = value.template || {};
        this.response = value.response || {};
        this.schema = this.template.schema || { sections: [], scales: {} };
        this.answers = value.answers || {};
        this.initialAnswers = JSON.parse(JSON.stringify(this.answers || {}));
        this.result = value.result || null;
        this.applyRevisionPayload(value);
        const currentKey = this.response.current_section || '';
        if (currentKey) {
            const idx = this.sections().findIndex((section: any) => section.key === currentKey);
            if (idx >= 0) this.sectionIdx = idx;
        }
        if (
            this.isOriginalForm()
            && this.response.subject_status === 'submitted'
            && this.response.admin_status !== 'submitted'
        ) {
            const adminIdx = this.sections().findIndex((section: any) =>
                section?.audience === 'admin_only'
                || section?.completionDeferred === true
            );
            if (adminIdx >= 0) this.sectionIdx = adminIdx;
        }
        await this.service.render();
    }

    private applyRevisionPayload(value: any) {
        const pagination = value?.revision_pagination || {};
        this.revisions = Array.isArray(value?.revisions) ? value.revisions : [];
        this.revisionPage = Number(pagination.page || 1);
        this.revisionPages = Number(pagination.pages || 0);
        this.revisionTotal = Number(pagination.total || 0);
        this.revisionPageSize = Number(pagination.dump || 5);
    }

    public async loadRevisionPage(page: number) {
        if (
            this.revisionLoading
            || page < 1
            || page > this.revisionPages
            || page === this.revisionPage
        ) return;

        this.revisionLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('get', {
            id: this.subjectId,
            form_code: this.formCode,
            revision_page: page,
        });
        this.revisionLoading = false;
        if (code !== 200) {
            alert((data && data.message) || '변경 이력을 불러오지 못했습니다.');
            await this.service.render();
            return;
        }
        this.applyRevisionPayload(this.payload(data));
        await this.service.render();
    }

    public sections(): any[] {
        const sections = this.schema && this.schema.sections;
        if (!Array.isArray(sections)) return [];
        const gender = this.subject?.gender || 'O';
        return sections.filter((section: any) => {
            const show = section && section.showIf;
            if (!show) return true;
            if (show.subjectField === 'gender' && show.eq !== undefined) {
                return gender === show.eq;
            }
            return true;
        });
    }

    public currentSection(): any {
        return this.sections()[this.sectionIdx] || null;
    }

    public scales(): any {
        return (this.schema && this.schema.scales) || {};
    }

    public hasValue(value: any): boolean {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string') return value.trim().length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object') {
            const values = Object.values(value);
            return values.length > 0 && values.some((item: any) => this.hasValue(item));
        }
        return true;
    }

    private questionVisibleWithAnswers(question: any, answers: any): boolean {
        const condition = question && question.showIf;
        if (!condition) return true;
        const value = condition.key ? answers?.[condition.key] : undefined;
        if (Array.isArray(condition.notIn)) {
            return value !== null && value !== undefined && condition.notIn.indexOf(value) < 0;
        }
        if (Array.isArray(condition.in)) {
            return value !== null && value !== undefined && condition.in.indexOf(value) >= 0;
        }
        if (condition.eq !== undefined) return value === condition.eq;
        if (condition.ne !== undefined) return value !== condition.ne;
        if (condition.gt !== undefined) return typeof value === 'number' && value > condition.gt;
        if (condition.gte !== undefined) return typeof value === 'number' && value >= condition.gte;
        if (condition.nonEmpty) return this.hasValue(value);
        return true;
    }

    public questionVisible(question: any): boolean {
        return this.questionVisibleWithAnswers(question, this.answers);
    }

    private embeddedQuestionKeys(parentKey: string): string[] {
        if (parentKey === 'psqi_5') return ['psqi_5_j', 'psqi_5_j1'];
        return [];
    }

    public visibleQuestions(section: any): any[] {
        if (!section || !Array.isArray(section.questions)) return [];
        const visible = section.questions.filter((question: any) => this.questionVisible(question));
        const hiddenKeys = new Set(['psqi_5_j', 'psqi_5_j1']);
        return visible
            .filter((question: any) => hiddenKeys.has(question.key) === false)
            .map((question: any) => {
                const embeddedKeys = this.embeddedQuestionKeys(question.key);
                if (embeddedKeys.length === 0) return question;
                const extraQuestions = visible.filter((item: any) => embeddedKeys.indexOf(item.key) >= 0);
                return extraQuestions.length > 0 ? { ...question, extraQuestions } : question;
            });
    }

    private allQuestions(): any[] {
        return this.sections().flatMap((section: any) =>
            Array.isArray(section?.questions) ? section.questions : []
        );
    }

    private clearQuestionTree(questionKey: string) {
        if (!questionKey) return;
        this.answers[questionKey] = null;
        for (const question of this.allQuestions()) {
            if (question?.showIf?.key === questionKey) {
                this.clearQuestionTree(question.key);
            }
        }
    }

    public onAnswerChange(event: any) {
        const questionKey = event && event.key;
        if (!questionKey) return;
        const previousAnswers = {
            ...this.answers,
            [questionKey]: event.previousValue,
        };
        for (const question of this.allQuestions()) {
            if (question?.showIf?.key !== questionKey) continue;
            const wasVisible = this.questionVisibleWithAnswers(question, previousAnswers);
            const isVisible = this.questionVisibleWithAnswers(question, this.answers);
            if (wasVisible !== isVisible) this.clearQuestionTree(question.key);
        }
    }

    public isQuestionAnswered(question: any): boolean {
        if (!question || question.optional === true) return true;
        const value = this.answers[question.key];

        if (question.type === 'table_matrix') {
            if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
            const rows = Array.isArray(question.rows) ? question.rows : [];
            if (!rows.every((row: any) => this.hasValue(value[row.key]))) return false;
            const extras = Array.isArray(question.extraQuestions) ? question.extraQuestions : [];
            return extras.every((extra: any) => this.isQuestionAnswered(extra));
        }
        if (question.type === 'obstetric' || question.type === 'smoke_detail') {
            if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
            const fields = Array.isArray(question.fields) ? question.fields : [];
            return fields.every((field: any) => this.hasValue(value[field.key]));
        }
        if (question.type === 'drink_row') {
            const required = ['type', 'amount', 'unit', 'count'];
            const rows = Array.isArray(value) ? value : [value];
            const active = rows.filter((row: any) =>
                row && typeof row === 'object' && required.some((key: string) => this.hasValue(row[key]))
            );
            return active.length > 0 &&
                active.every((row: any) => required.every((key: string) => this.hasValue(row[key])));
        }
        if (!this.hasValue(value)) return false;
        const extras = Array.isArray(question.extraQuestions) ? question.extraQuestions : [];
        return extras.every((extra: any) => this.isQuestionAnswered(extra));
    }

    private conditionMatches(condition: any, values: any): boolean {
        if (!condition) return true;
        const value = condition.key ? values?.[condition.key] : undefined;
        if (condition.eq !== undefined) return value === condition.eq;
        if (condition.ne !== undefined) return value !== condition.ne;
        if (Array.isArray(condition.in)) return condition.in.indexOf(value) >= 0;
        if (Array.isArray(condition.notIn)) return condition.notIn.indexOf(value) < 0;
        if (condition.nonEmpty) return this.hasValue(value);
        return true;
    }

    private genderMatches(item: any): boolean {
        return !item?.gender || item.gender === this.subject?.gender;
    }

    private isAdminQuestionComplete(question: any): boolean {
        const value = this.answers?.[question?.key];
        if (question?.type === 'clinical_form') {
            const values = value && typeof value === 'object' ? value : {};
            const status = question.status || {};
            if (!this.hasValue(values[status.key || 'status'])) return false;
            const reason = question.reason || null;
            if (reason && this.conditionMatches(reason.showIf, values)) {
                return this.hasValue(values[reason.key]);
            }
            for (const group of question.groups || []) {
                if (!this.conditionMatches(group?.showIf, values)) continue;
                for (const field of group?.fields || []) {
                    if (!this.genderMatches(field)) continue;
                    if (!this.conditionMatches(field?.showIf, values)) continue;
                    if (!this.hasValue(values[field.key])) return false;
                }
            }
            return true;
        }
        if (question?.type === 'lab_results') {
            const values = value && typeof value === 'object' ? value : {};
            const status = values.status;
            if (status !== 'performed' && status !== 'nd') return false;

            if (status === 'performed') {
                const results = (
                    values.results
                    && typeof values.results === 'object'
                    && !Array.isArray(values.results)
                ) ? values.results : {};
                const rowsComplete = (question.rows || [])
                    .filter((row: any) => this.genderMatches(row))
                    .every((row: any) => {
                        const rowValue = (
                            results[row.key]
                            && typeof results[row.key] === 'object'
                            && !Array.isArray(results[row.key])
                        ) ? results[row.key] : {};
                        if (!this.hasValue(rowValue.value)) return false;
                        if (['normal', 'ncs', 'cs'].indexOf(rowValue.classification) < 0) {
                            return false;
                        }
                        return rowValue.classification !== 'cs'
                            || this.hasValue(rowValue.finding);
                    });
                if (!rowsComplete) return false;
            } else {
                if (['screening_failure', 'other'].indexOf(values.nd_reason) < 0) {
                    return false;
                }
                if (
                    values.nd_reason === 'other'
                    && !this.hasValue(values.nd_reason_other)
                ) return false;
            }

            if (values.sample_collected !== 'Y' && values.sample_collected !== 'N') {
                return false;
            }
            if (values.sample_collected === 'N') {
                if (['screening_failure', 'other'].indexOf(values.sample_reason) < 0) {
                    return false;
                }
                if (
                    values.sample_reason === 'other'
                    && !this.hasValue(values.sample_reason_other)
                ) return false;
            }
            return true;
        }
        return this.hasValue(value);
    }

    public validateAll(): boolean {
        for (const section of this.sections()) {
            const isAdmin = (
                section?.audience === 'admin_only'
                || section?.completionDeferred === true
            );
            if (isAdmin && !this.isOriginalForm()) continue;
            for (const question of this.visibleQuestions(section)) {
                const complete = isAdmin
                    ? this.isAdminQuestionComplete(question)
                    : this.isQuestionAnswered(question);
                if (!complete) {
                    const sectionIndex = this.sections().indexOf(section);
                    if (sectionIndex >= 0) this.sectionIdx = sectionIndex;
                    alert('미응답 문항을 확인해주세요: ' + (question.label || question.key));
                    void this.service.render();
                    return false;
                }
            }
        }
        return true;
    }

    public answeredCount(): number {
        let count = 0;
        for (const section of this.sections()) {
            if (section?.completionDeferred === true) continue;
            for (const question of this.visibleQuestions(section)) {
                if (this.isQuestionAnswered(question)) count++;
            }
        }
        return count;
    }

    public questionCount(): number {
        return this.sections().reduce(
            (sum: number, section: any) =>
                sum + (section?.completionDeferred === true ? 0 : this.visibleQuestions(section).length),
            0,
        );
    }

    private answerEqual(before: any, after: any): boolean {
        return JSON.stringify(before) === JSON.stringify(after);
    }

    private changedAnswerKeys(): string[] {
        const keys = new Set([
            ...Object.keys(this.initialAnswers || {}),
            ...Object.keys(this.answers || {}),
        ]);
        return Array.from(keys).filter((key: string) =>
            !this.answerEqual(
                this.initialAnswers?.[key],
                this.answers?.[key],
            )
        );
    }

    private adminQuestionKeys(): Set<string> {
        const keys = new Set<string>();
        for (const section of this.sections()) {
            if (
                section?.audience !== 'admin_only'
                && section?.completionDeferred !== true
            ) continue;
            for (const question of section?.questions || []) {
                if (question?.key) keys.add(question.key);
            }
        }
        return keys;
    }

    private correctionReason(): string | null {
        const changed = this.changedAnswerKeys();
        if (changed.length === 0) return '';

        let required = this.response.status === 'submitted';
        if (this.isOriginalForm()) {
            const adminKeys = this.adminQuestionKeys();
            required = (
                this.response.admin_status === 'submitted'
                && changed.some((key: string) => adminKeys.has(key))
            ) || (
                this.response.subject_status === 'submitted'
                && changed.some((key: string) => !adminKeys.has(key))
            );
        }
        if (!required) return '';

        const reason = prompt('완료된 기록을 수정하는 사유를 입력해주세요.', '');
        if (reason === null) return null;
        if (!reason.trim()) {
            alert('수정 사유는 필수입니다.');
            return null;
        }
        return reason.trim();
    }

    private async persist(
        action: 'save' | 'submit',
        options: any = {},
    ): Promise<boolean> {
        if (!this.template.schema_ready) return false;
        if (action === 'submit' && !this.validateAll()) return false;
        const reason = this.correctionReason();
        if (reason === null) return false;
        if (action === 'submit' && !confirm(this.submitConfirmText())) return false;

        this.saving = action === 'save';
        this.submitting = action === 'submit';
        await this.service.render();
        const section = this.currentSection();
        const currentSectionKey = options.currentSectionKey !== undefined
            ? options.currentSectionKey
            : (section ? section.key || '' : '');
        const answersToSave = options.changedOnly
            ? this.changedAnswerKeys().reduce((result: any, key: string) => {
                result[key] = this.answers[key];
                return result;
            }, {})
            : this.answers;
        const { code, data } = await wiz.call(action, {
            id: this.subjectId,
            form_code: this.formCode,
            answers: JSON.stringify(answersToSave),
            current_section: currentSectionKey,
            reason,
            revision: Number(this.response.revision || 0),
            compact: options.reload === false,
        });
        this.saving = false;
        this.submitting = false;
        if (code === 200) {
            if (!options.silent) {
                alert(
                    action === 'submit'
                        ? (
                            this.isOriginalForm()
                                ? '관리자 임상 기록을 완료했습니다.'
                                : '완료 처리되었습니다.'
                        )
                        : '저장되었습니다.'
                );
            }
            if (options.reload === false) {
                const value = this.payload(data);
                this.response = {
                    ...this.response,
                    ...(value.response || {}),
                };
                if (value.result !== undefined) this.result = value.result;
                this.initialAnswers = JSON.parse(JSON.stringify(this.answers || {}));
            } else {
                await this.load();
            }
            return true;
        } else {
            alert((data && data.message) || (action === 'submit' ? '완료 처리 실패' : '저장 실패'));
            await this.service.render();
            return false;
        }
    }

    public async save() {
        await this.persist('save');
    }

    public async submit() {
        await this.persist('submit');
    }

    private async navigateTo(targetIndex: number) {
        const sections = this.sections();
        if (
            this.saving
            || this.submitting
            || targetIndex < 0
            || targetIndex >= sections.length
        ) return;

        if (this.changedAnswerKeys().length > 0) {
            const targetSection = sections[targetIndex];
            const saved = await this.persist('save', {
                silent: true,
                reload: false,
                changedOnly: true,
                currentSectionKey: targetSection?.key || '',
            });
            if (!saved) return;
        }

        this.sectionIdx = targetIndex;
        await this.service.render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public async previous() {
        await this.navigateTo(this.sectionIdx - 1);
    }

    public async next() {
        await this.navigateTo(this.sectionIdx + 1);
    }

    public statusLabel(status: string): string {
        const labels: any = {
            pending: '미작성',
            in_progress: '작성 중',
            admin_pending: '관리자 기록 대기',
            submitted: '완료',
        };
        return labels[status] || status || '미작성';
    }

    public statusClass(status: string): string {
        const classes: any = {
            pending: 'bg-slate-100 text-slate-700',
            in_progress: 'bg-amber-100 text-amber-700',
            admin_pending: 'bg-indigo-100 text-indigo-700',
            submitted: 'bg-emerald-100 text-emerald-700',
        };
        return classes[status] || classes.pending;
    }

    public isOriginalForm(): boolean {
        return this.formCode === 'original_survey';
    }

    public overallStatus(): string {
        return this.response?.overall_status || this.response?.status || 'pending';
    }

    public adminProgressLabel(): string {
        const completed = Number(this.response?.admin_completed || 0);
        const total = Number(this.response?.admin_total || 0);
        return total > 0 ? completed + ' / ' + total + ' 항목' : '입력 대기';
    }

    public saveButtonLabel(): string {
        if (this.saving) return '저장 중...';
        const status = this.isOriginalForm()
            ? this.response?.admin_status
            : this.response?.status;
        return status === 'submitted' ? '수정 저장' : '임시 저장';
    }

    public submitButtonLabel(): string {
        if (this.submitting) return '처리 중...';
        if (!this.isOriginalForm()) {
            return this.response?.status === 'submitted'
                ? '수정 후 완료'
                : '완료 처리';
        }
        return this.response?.admin_status === 'submitted'
            ? '수정 후 완료'
            : '관리자 기록 완료';
    }

    public submitConfirmText(): string {
        if (this.isOriginalForm()) {
            return '대상자 설문과 관리자 임상 기록을 확인하고 CRF를 완료하시겠습니까?';
        }
        return '현재 내용을 완료 처리하시겠습니까?';
    }

    public entryLabel(): string {
        if (this.definition.audience === 'admin_only') return '관리자 전용';
        return '관리자 대리 입력';
    }

    public isDepressionForm(): boolean {
        return this.formCode === 'geriatric_depression';
    }

    public isMmseForm(): boolean {
        return this.formCode === 'mmse';
    }

    public subjectGenderLabel(): string {
        const labels: any = {
            M: '남',
            F: '여',
            O: '미입력',
        };
        return labels[this.subject?.gender] || '미입력';
    }

    public subjectAge(): string {
        const birth = String(this.subject?.birth || '');
        const match = birth.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return '-';

        const referenceValue = String(this.answers?.mmse_exam_date || '');
        const referenceMatch = referenceValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        const now = new Date();
        const year = referenceMatch ? Number(referenceMatch[1]) : now.getFullYear();
        const month = referenceMatch ? Number(referenceMatch[2]) : now.getMonth() + 1;
        const day = referenceMatch ? Number(referenceMatch[3]) : now.getDate();
        const birthYear = Number(match[1]);
        const birthMonth = Number(match[2]);
        const birthDay = Number(match[3]);

        let age = year - birthYear;
        if (month < birthMonth || (month === birthMonth && day < birthDay)) age--;
        return age >= 0 ? age + '세 (만)' : '-';
    }

    public mmseResultLabel(): string {
        if (!this.result?.complete) {
            return (this.result?.answered || 0) + ' / ' + (this.result?.item_count || 12) + ' 입력';
        }
        return this.result?.classification?.label || '판정 대기';
    }

    public mmseResultClass(): string {
        if (!this.result?.complete) return 'is-pending';
        const key = this.result?.classification?.key || '';
        if (key === 'normal') return 'is-normal';
        if (key === 'suspected') return 'is-warning';
        return 'is-flagged';
    }

    public mmseSubdomainSummary(domain: any): string {
        const subdomains = Array.isArray(domain?.subdomains) ? domain.subdomains : [];
        return subdomains
            .map((item: any) =>
                item.label + ' ' + item.score + '/' + item.max_score +
                (item.bonus ? ' (+' + item.bonus + ')' : '')
            )
            .join(' · ');
    }

    public resultLabel(): string {
        if (!this.result?.complete) return '15문항 입력 대기';
        return this.result.flagged ? '상담 권고 기준 해당' : '상담 권고 기준 미해당';
    }

    public resultClass(): string {
        if (!this.result?.complete) return 'is-pending';
        return this.result.flagged ? 'is-flagged' : 'is-normal';
    }

    public revisionSourceLabel(source: string): string {
        const labels: any = {
            subject: '대상자 입력',
            admin_proxy: '관리자 대리 입력',
            admin: '관리자 입력',
            system_migration: '시스템 반영',
        };
        return labels[source] || '관리자 입력';
    }

    public trackByQuestion(index: number, question: any): string {
        return question?.key || String(index);
    }
}

export default PageAdminFormsItemComponent;